import { post } from './axios.js'

/**
 * getApiCodeList - /common/getMsgList
 * @returns
 */
export async function getMsgList() {
  try {
    const result = await post('/common/getMsgList', {})
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * getCodeDtlList - /conf/codeGrpDtlList
 * @param {object} params
 * @returns
 */
export async function codeGrpDtlList(params = {}) {
  try {
    const result = await post('/conf/codeGrpDtlList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}